
import { z } from "zod";

export const PermittingEntityValues = ["CONTRACTOR", "REMI"] as const;
export const PermittingEntitySchema = /* @__PURE__ */ z.enum(PermittingEntityValues);
export const PermittingEntity: (typeof PermittingEntitySchema)["enum"] = { "CONTRACTOR": "CONTRACTOR", "REMI": "REMI" };
export type PermittingEntity = (typeof PermittingEntityValues)[number];
export const PermittingEntityDisplayNames = { "CONTRACTOR": "Contractor",
"REMI": "Remi", } satisfies Record<PermittingEntity, string>;
